import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTimestampFromNow } from "../../Utils/timeHelper";
import CommentForm from "../CommentForm";
import ProfilePicture from "../ProfilePicture";
import styles from "./style.module.scss";

function Comment({ data, onClickRedirect, onClickDelete, loggedInUser }) {
	const { _id, content, creator, createdAt, comments } = data;
	const navigate = useNavigate();
	const [onReply, setOnReply] = useState(false);
	const [displaySubcomment, setDisplaySubcomment] = useState(false);
	const renderSubComments = () => {
		const getActionText = () => {
			if (!displaySubcomment) {
				return `View all ${comments.length} comments`;
			}
			return "Hide comments";
		};
		if (comments.length > 0) {
			return (
				<div className={styles.subComments}>
					<div
						onClick={() => setDisplaySubcomment(!displaySubcomment)}
						className={styles.containerOpenSubcomment}
					>
						----<p className={styles.openSubcomment}>{getActionText()}</p>
					</div>
					{displaySubcomment ? (
						<div>
							{comments.map((comment, index) => {
								return (
									<Comment
										data={comment}
										key={index}
										loggedInUser={loggedInUser}
										onClickDelete={onClickDelete}
									/>
								);
							})}
						</div>
					) : null}
				</div>
			);
		}
	};
	const onClickCreator = () => {
		if (loggedInUser === creator.username) {
			navigate("/");
		} else {
			navigate("/" + creator.username);
		}
	};
	return (
		<div>
			<div className={styles.replyContainer}>
				<div className={styles.subContainerCreator}>
					<ProfilePicture
						url={creator.profilePicture}
						isComment={true}
						onClick={onClickRedirect}
					/>
					<div className={styles.creator} onClick={onClickCreator}>
						<p onClick={onClickRedirect} className={styles.name}>
							{creator.name}
						</p>
						<p className={styles.username}>{"@" + creator.username}</p>
					</div>
				</div>
				<div>
					<div className={styles.contentContainer}>
						<p className={styles.content}>{content}</p>
						<div className={styles.subContainerTime}>
							<p className={styles.timestamp}>
								{getTimestampFromNow(createdAt)}
							</p>
							<b onClick={() => setOnReply(!onReply)}>
								{!onReply ? "Reply" : "Close"}
							</b>
							{loggedInUser === creator.username ? (
								<b onClick={() => onClickDelete(_id)}>Delete</b>
							) : (
								""
							)}
						</div>
					</div>
				</div>
			</div>
			{renderSubComments()}
			{onReply ? (
				<div className={styles.commentForm}>
					<CommentForm parentId={_id} active={onReply} setActive={setOnReply} />
				</div>
			) : null}
		</div>
	);
}
export default Comment;
